export default [
  {
    section: 'REGISTRATION',
    list: [
      [
        'who can become a Lender in Kredit Pintar?',
        'Indonesian Citizens (WNI) or Foreign Citizens (WNA) at least 18 years old. For Indonesian citizens, the validity of their identity will be proven through their ID card and Bank Account in Indonesia. Whereas for foreigners, you can contact Kredit Pintar Customer Service.',
      ],
      [
        'Aside from KTP, can use another identity card to become a Lender in Kredit Pintar?',
        'The terms and conditions of being a Lender through an original (KTP) document, cannot use SIM documents, photocopy of KTP (not original) or other identity cards.',
      ],
      [
        'How to register as a Lender in Kredit Pintar?',
        'Download the application "Kredit Pintar For Lenders" both on iOS and Android, or open the website www.kreditpintar.com. After that, verify the phone number and you will get an OTP code via SMS',
      ],
      [
        'How to create a password in the Lender account in Kredit Pintar?',
        'Password in the Lender account in Kredit Pintar must contain 8-16 characters consisting of a combination of "letters" and "numbers"',
      ],
    ],
  },
  {
    section: 'KYC (Know Your Customer)',
    list: [
      [
        'What needs to be done when already registered in the Lending account?',
        '<div>1. Upload a photo of the Original ID card (KTP) for the verification process</div>' +
        '<div>2. Our system will match the identity on the account and ID card. If there is a data mismatch, please re-upload it with the Original ID card (KTP) and clearer photo.</div>',
      ],
      [
        'What is the next step if the funding account has been completed?',
        '<div>1. Enter the bank account data</div>' +
        '<div>2. Make sure the name on the bank account matches with the name on ID card (KTP). If there are differences in names regarding titles etc., you can contact our Customer Service.</div>' +
        '<div>3. Substitution of the bank account can do maximum of 3x per month.</div>',
      ],
    ],
  },
  {
    section: 'Top Up Balances',
    list: [
      [
        'When can I top up the balance?',
        'After verified the Lender Account, you can top up your balance whenever you want.',
      ],
      [
        'What are the methods for top up the available balances?',
        'Top up the balances can be done through Virtual Account (VA), GOPAY, or manual transfers. For VA, VA BCA is available (transfer only from a BCA account), VA BNI (accepting from all bank accounts). Manual Transfer can use CIMB Bank account. While GOPAY, money will enter into funding automatically after the transaction without entering the remaining balance.',
      ],
      [
        'Are there any minimum / maximum transfer limit with the top up method?',
        '<div>The minimum transfer applies to manual transfers with nominal amount of Rp. 500 million.</div>' +
        '<div>The maximum transfer is valid for GOPAY with nominal amount of IDR 10 million.</div>',
      ],
      [
        'How long the funds can enter to funding account?',
        'For VA & Gopay, funds are received in real time. As for manual transfers, funds will be received 1x24 hours after confirming our Customer Service.',
      ],
      [
        'Can I withdraw money that has been top up into the Kredit Pintar balance?',
        'Yes, you can withdraw money that already in the Kredit Pintar balance, if you have not started Funding',
      ],
    ],
  },
  {
    section: 'FUNDING',
    list: [
      [
        'What are the Kredit Pintar Funding products available?',
        'You can choose the product that macthes your needs. The following 3 types of funding products we offer:' +
        '<div style="padding-left: 15px">' +
        '<div>1. Flexible Funding: Lenders can withdraw funds at any time (min. 24 hours after funding) with interest received 9% (p.a.).</div>' +
        '<div>2. Term Funding: Lenders can withdraw funds at the end of the funding period with interest adjusted to the chosen funding period, as follows.</div>' +
        '<div style="padding-left: 25px">' +
        '<div>- 7 days, interest of 20% (p.a.)</div>' +
        '<div>- 30 days, interest 12% (p.a.)</div>' +
        '<div>- 90 days, interest 14% (p.a.)</div>' +
        '<div>- 180 days, interest 16% (p.a.)</div>' +
        '<div>- 365 days, interest is 18% (p.a.)</div>' +
        '</div>' +
        '<div>3. VIP-Term Funding: Lenders can withdraw funds at the end of the funding period with interest adjusted to the chosen funding period, as follows.</div>' +
        '<div style="padding-left: 25px">' +
        '<div>- 30 days, interest 15% (p.a.)</div>' +
        '<div>- 90 days, interest 16% (p.a.)</div>' +
        '<div>- 180 days, interest 18% (p.a.)</div>' +
        '<div>- 365 days, interest of 20% (p.a.)</div>' +
        '</div>' +
        '</div>',
      ],
      [
        'How much the minimum and maximum nominal of Funding in Kredit Pintar?',
        '<div>1. For flexible funding, the minimum funding is IDR 50 thousand & maximum IDR 10 million.</div>' +
        '<div>2. For term funding, the minimum funding is IDR 50 thousand, without maximum.</div>' +
        '<div>3. For VIP-term funding, the minimum funding is IDR 1 M, without maximum.</div>',
      ],
      [
        'Can I withdraw money that has been disbursed before the funding period ends?',
        '<div>For Terms & VIP Funding products, you cannot withdraw money in funding before the funding period ends.</div>' +
        '<div>As for Flexible Funding, withdrawals can be made at least 24 hours from the time of funding.</div>',
      ],
      [
        'When can I withdraw funds and the profit?',
        '<div>For Term and VIP Funding, initial capital plus interest can be disbursed when the funding period ends.</div>' +
        '<div>While Funding Flexible, funds can be withdraw at any time.</div>' +
        '<div>We will send the notification SMS when your funding has expired.</div>',
      ],
      [
        'What is meant by "Discount" in the description on the funding account?',
        'Discounts are special programs that give you more benefits in funding. Discounts can be in the form of vouchers or coupons.' +
        '<div style="padding-left: 15px">' +
        '<div>- Voucher: In the form of code provided by Smart Credit on certain occasions / events. After the code is entered, there will be a new funding product offer on your account. The benefits received are in the form of bigger interest.</div>' +
        '<div>- Coupons: Unlike vouchers, coupons will automatically be on your account (based on certain ratings) or through links (when there are certain events or occasions). Coupons have several types:</div>' +
        '<div style="padding-left: 25px">' +
        '<div>1. Extramoney: Is the money given to you, where you will get the money when making funding first.</div>' +
        '<div>2. Cashback: Is the money given to you, where the money will go into the remaining balance and can be withdrawn or used for funding.</div>' +
        '<div>3. Extra Interest Rate: An additional interest given from the usual interest received.</div>' +
        '</div>' +
        '</div>' +
        '*) terms and Conditions apply',
      ],
    ],
  },
  {
    section: 'GENERAL',
    list: [
      [
        'How much the minimum and maximum value set to start funding in Kredit Pintar?',
        'The minimum deposit to start funding in Kredit Pintar are IDR 50,000, without maximum.',
      ],
      [
        'Are there any fees for funding in Kredit Pintar?',
        'Kredit Pintar does not collect any fees from Lenders.',
      ],
      [
        'When can I liquate the funds and profits?',
        'You can withdraw funds when the funding period ends (capital plus interest earned). Withdrawals can be made if the minimum balance are IDR 10 thousand.',
      ],
      [
        'Is it safe to become a Lender in Kredit Pintar?',
        'Yes, safe. Kredit Pintar selects and analyzes all prospective borrowers. By using the Credit Scoring Model Technology that we apply to only borrowers who meet the eligibility criteria who can make loans in Kredit Pintar. We uphold transparency for the risk holders. Currently Kredit Pintar has been officially registered as a Fintech company which has been overseen by the Financial Services Authority (OJK) since April 2018.',
      ],
      [
        'Are there any risk of becoming a Lender in Kredit Pintar?',
        'There is. However Kredit Pintar has carried out risk reduction by implementing Credit Scoring based on Artificial Intelligence (AI) technology. With the calculation and management of risk in the analysis process of all submissions and lending, the risk can be reduced to a minimum level',
      ],
      [
        'How if the Borrower unsuccessfull to make a payment',
        'To minimize default risk,  Kredit Pintar will conduct analysis, selection and approval based on the latest Credit Scoring system for each loan submitted. After the Lender funds are disbursed to the Borrower, Kredit Pintar continues to supervise to ensure that there is no misuse of the funds provided. Repayment can be carried out on time. If the Borrower experiences default, Kredit Pintar will immediately take action to protect the interests of the Lender.',
      ],
      [
        'How to contact Kredit Pintar funding Customer Service?',
        '<div>Whatsapp: 081324887208</div>' +
        '<div>Email: pendanaan@kreditpintar.com</div>' +
        '<div>Working Hours : Monday - Friday (09:30 -19:30)</div>',
      ],
    ],
  },
  {
    section: 'REFUND',
    list: [
      [
        'The refund process to the Lender\'s bank account',
        'We make the limit for deposit time of funds that have been deposited to Kredit Pintar for 48 hours from the time the funds enter Smart Credit. Our system will automatically return the funds to the registered bank account if after 48 hours the funds are not used for funding or not withdrawn.',
      ],
    ],
  },
]
